import { requestCDN } from "../../../../apis";
import localStorageKey from "../../../../enumerations/localStorageKey";

const defaultCurrency = localStorage.getItem(localStorageKey.DEFAULT_CURRENCY);

export const apiGetStatistics = (params) => {
  const millis = Date.now();
  return requestCDN(
    "get",
    `/${defaultCurrency?.toUpperCase()}/summary/statistics.json?v=${millis}`,
  );
  // return requestMain("get", `/${defaultCurrency}/summary/statistics`, params, false, false);
};
